import React from 'react';
import { PDFImagesViewFullWidth } from 'components/v2/images-upload/PDFImagesViewFullWidth';
import { PdfH2, PdfP, PdfPage } from './Styles.styled';
import styled from 'styled-components';
import usePdfData from './utils/usePdfData';

const ProcessFlowDiagramsDescriptionPage: React.FC = () => {
  const { systemBoundary } = usePdfData();

  if (!systemBoundary) {
    return null;
  }

  const pageContent = [
    systemBoundary.processFlowDiagramsDescription && (
      <div key="description">
        <NoMarginsH2>Description of the process flow diagram(s)</NoMarginsH2>
        <DescriptionParagraph>{systemBoundary.processFlowDiagramsDescription}</DescriptionParagraph>
      </div>
    ),
    systemBoundary.processFlowDiagramsImages.length > 0 && (
      <React.Fragment key="images">
        <NoMarginsH2>Process flow diagram(s) related images</NoMarginsH2>
        <PDFImagesViewFullWidth images={systemBoundary.processFlowDiagramsImages} />
      </React.Fragment>
    ),
  ];

  if (pageContent.filter(Boolean).length === 0) {
    return null;
  }

  return (
    <PdfPage>
      <Content>{pageContent}</Content>
    </PdfPage>
  );
};

export default ProcessFlowDiagramsDescriptionPage;

const Content = styled.div`
  display: grid;
  gap: 16pt;
`;

const DescriptionParagraph = styled(PdfP)`
  margin-top: 8pt;
  margin-bottom: 8pt;
`;

const NoMarginsH2 = styled(PdfH2)`
  margin: 0;
`;
